import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'messenger',
  title: '消息',
  provides: {
    /** 工作台内嵌的消息主视图 */
    'messenger.main': () => import('./MessengerView.vue'),
  },
  routes: [
    { path: '/messenger', name: 'messenger', component: () => import('./MessengerView.vue'), meta: { tab: 'messenger' } },
  ],
} satisfies FeatureModule
